import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createColumnHelper, Table, useTable } from "@components/mantine";
import { keepPreviousData, Platform, useQuery } from "@core/api";
import { GenericGranularPrivilegesTable } from "../GenericGranularPrivilegesTable.js";
import { Locales } from "../../../../strings/Locales.js";
var columnHelper = createColumnHelper();
var columns = [
    columnHelper.accessor("name", {
        header: Locales.format("PrivilegesTable.Pipelines.column.name.header"),
        enableSorting: false
    })
];
export var QueryPipelinesPrivilegesTable = function(props) {
    var store = useTable();
    var query = useQuery({
        queryKey: [
            "pipeline",
            "list",
            store.state.pagination
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Platform.pipeline.list({
                                enablePagination: true,
                                page: store.state.pagination.pageIndex,
                                perPage: store.state.pagination.pageSize
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        store.setTotalEntries(response.totalEntries);
                        return [
                            2,
                            response.items
                        ];
                }
            });
        }),
        placeholderData: keepPreviousData
    });
    return /*#__PURE__*/ _jsx(GenericGranularPrivilegesTable, _object_spread_props(_object_spread({
        store: store,
        columns: columns,
        query: query,
        resourceName: props.name.toLowerCase()
    }, props), {
        children: /*#__PURE__*/ _jsxs(Table.Footer, {
            children: [
                /*#__PURE__*/ _jsx(Table.PerPage, {}),
                /*#__PURE__*/ _jsx(Table.Pagination, {})
            ]
        })
    }));
};

//# sourceMappingURL=QueryPipelinesPrivilegesTable.js.map